var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"md-content",domProps:{"innerHTML":_vm._s(_vm.markdown)}})
}
var staticRenderFns = []

export { render, staticRenderFns }